import React from 'react';
import classnames from 'classnames';
import Input from './Input';
import Checkbox from './Checkbox';
import { fieldPropTypes } from '../shapes';

const Field = ({
  id,
  label,
  type,
  error,
  errorMessage,
  onChange,
  onBlur,
  autoComplete,
  name,
  required,
  className,
  value,
}) => (
  <div className={classnames('c-field', className)}>
    {
      type === 'checkbox' ?
        <Checkbox {...{ id, label, onChange, name, required }} />
      :
        <Input
          autoCorrect="off"
          spellCheck="false"
          {...{ id, label, onChange, onBlur, type, autoComplete, name, required, value }}
        />
    }
    {error &&
    <div className="c-field__message" style={{ color: 'red' }}>
      {errorMessage}
    </div>}
  </div>
);
Field.propTypes = fieldPropTypes;
Field.defaultProps = {
  type: 'text',
  errorMessage: 'Please fill field',
  error: false,
  name: '',
  autoComplete: 'on',
  required: false,
  onChange: null,
  onBlur: null,
};

export default Field;



// WEBPACK FOOTER //
// ./src/app/components/Field.jsx